import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import styles from "src/components/UI/Shared/assets/scss/Notification.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

const Notification = () => {
  const dispatch = useDispatch();
  const notification = useSelector((state: any) => state.app.Notification);
  const handleCloseToast = () => {
    dispatch(
      appActions.setNotification({
        open: false,
        message: "null",
        severity: "null",
      })
    );
  };
  return (
    <Snackbar
      className={styles.snackbar}
      open={notification.open && notification.message !== "null"}
      autoHideDuration={5000}
      onClose={handleCloseToast}
      key={"bottom" + "center"}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={handleCloseToast}
        severity={
          notification.severity === "success"
            ? "success"
            : notification.severity === "warning"
            ? "warning"
            : notification.severity === "info"
            ? "info"
            : "error"
        }
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
